module.exports = __webpack_public_path__ + "static/media/2.b9a87db1.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/orgasm/2.wav
// module id = 502
// module chunks = 0